import React from "react";
import { Mail, Phone, MessageCircle, MapPin, Clock } from "lucide-react";

const CONTACT_CARDS = [
  { testId: "contact-office", Icon: MapPin, label: "Head office", lines: ["Beawar, Rajasthan", "India — 305901"] },
  { testId: "contact-phone", Icon: Phone, label: "Sales", lines: ["+91 97825 19708", "+91 91663 63761", "Mon-Sat · 9 AM – 8 PM IST"] },
  { testId: "contact-support", Icon: Mail, label: "Support", lines: ["support@ranaassociate.com", "Response < 24 hours"] },
  { testId: "contact-hours", Icon: Clock, label: "Operations", lines: ["24×7 lead intake", "Site visits within 48 hrs"] },
];

export default function ContactCTASection() {
  return (
    <section id="contact" className="bg-gradient-to-br from-slate-950 via-slate-900 to-amber-950 text-white py-16 sm:py-24" data-testid="contact-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-3">Onboard your bank</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold leading-tight">
            Ready to run property valuations across all 33 districts of Rajasthan?
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed max-w-lg">
            Sign a simple B2B agreement in one meeting. First lead can be generated the same day.
            Executives are onboarded per pincode with KYC verification.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="mailto:partnerships@ranaassociate.com"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-950 font-semibold px-5 py-3 rounded-md text-sm"
              data-testid="cta-email"
            >
              <Mail className="h-4 w-4" /> partnerships@ranaassociate.com
            </a>
            <a
              href="https://wa.me/919782519708"
              target="_blank"
              rel="noreferrer noopener"
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-3 rounded-md text-sm"
              data-testid="cta-whatsapp"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Sales
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CONTACT_CARDS.map(({ Icon, ...card }) => <ContactCard key={card.testId} icon={<Icon className="h-5 w-5" />} {...card} />)}
        </div>
      </div>
    </section>
  );
}

function ContactCard({ icon, label, lines, testId }) {
  return (
    <div className="bg-white/5 border border-white/10 rounded-lg p-5 backdrop-blur-sm" data-testid={testId}>
      <div className="h-9 w-9 rounded-md bg-amber-500/20 text-amber-300 flex items-center justify-center mb-3">
        {icon}
      </div>
      <div className="text-[11px] font-bold uppercase tracking-widest text-amber-200/80">{label}</div>
      <div className="mt-1 text-sm text-slate-100 leading-relaxed">
        {lines.map((l) => <div key={l}>{l}</div>)}
      </div>
    </div>
  );
}
